module.exports = __webpack_public_path__ + "static/media/sbom-slide-7.3266f5a1.jpg";